import { render, staticRenderFns } from "./DetalleCorrectivaForm.vue?vue&type=template&id=a8cbf6d0&scoped=true&"
import script from "./DetalleCorrectivaForm.vue?vue&type=script&lang=ts&"
export * from "./DetalleCorrectivaForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleCorrectivaForm.vue?vue&type=style&index=0&id=a8cbf6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cbf6d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a8cbf6d0', component.options)
    } else {
      api.reload('a8cbf6d0', component.options)
    }
    module.hot.accept("./DetalleCorrectivaForm.vue?vue&type=template&id=a8cbf6d0&scoped=true&", function () {
      api.rerender('a8cbf6d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/HistoricoMantenimiento/DetalleCorrectivaForm.vue"
export default component.exports